module.exports = __webpack_public_path__ + "static/media/mudeyPurpleProYellow.495a97c3.svg";